import { fetcher } from '@commenda/utils';

export async function deleteSecureInformationRequestTemplate(
  secureInformationRequestTemplateId: string,
  token: string | undefined
) {
  const response = await fetcher(
    `secureInformationRequestTemplate/${secureInformationRequestTemplateId}`,
    {
      method: 'DELETE',
    },
    token
  );

  return response;
}
